import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { createOAuthColumns } from "./table/columns";

type OAuthViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type OAuthViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useOAuthViewOptions = ({
  onVisibilityChange,
}: OAuthViewOptionsProps = {}): OAuthViewOptionsReturn => {
  // Get column definitions
  const columns = useMemo(() => createOAuthColumns(), []);

  // Use the generic table view options hook
  return useTableViewOptions({
    columns,
    storageKey: "oauth-table-column-visibility",
    onVisibilityChange,
    label: "Columns",
    className: "h-8 px-4 gap-2 shadow-sm",
  });
};
